// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Uynn5","disabled":"FileBtn_disabled__arj6Q","warn":"FileBtn_warn__2Zal4","fade":"FileBtn_fade__3tqGI"};